var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSnacksIcon = function SvgSnacksIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.985 15.202a6.983 6.983 0 100-13.967 6.983 6.983 0 000 13.967z",
    fill: "#004CCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.244 20.765a4.304 4.304 0 100-8.608 4.304 4.304 0 000 8.608z",
    fill: "#004CCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.666 18.085a4.141 4.141 0 100-8.283 4.141 4.141 0 000 8.283zM17.171 15.364a4.304 4.304 0 100-8.607 4.304 4.304 0 000 8.607z",
    fill: "#004CCC"
  })));
};

export default SvgSnacksIcon;